import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DirectoryComponent, LandingPageComponent } from '@sondermind/features/provider-profile-page';

import { OnePageCheckoutFeatureFlagGuard } from './guards/one-page-checkout-feature-flag.guard';

const routes: Routes = [
  {
    path: 'one-page-checkout',
    canMatch: [OnePageCheckoutFeatureFlagGuard],
    loadChildren: () => import('@sondermind/features/public-facing/one-page-checkout').then((m) => m.onePageCheckoutRoutes),
  },
  {
    path: '',
    component: DirectoryComponent,
  },
  {
    path: ':share_code/one-page-checkout',
    canMatch: [OnePageCheckoutFeatureFlagGuard],
    loadChildren: () => import('@sondermind/features/public-facing/one-page-checkout').then((m) => m.onePageCheckoutRoutes),
  },
  {
    path: ':share_code',
    component: LandingPageComponent
  },
  {
    path: ':share_code/:name',
    component: LandingPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
